import { isAdminPreferencePath } from '@/lib/menuPermissions.core';

export type RouteRole = 'ADMIN' | 'USER' | 'AGENT' | 'RIDER';

/**
 * The role a `<RoleRoute>` judges a user by. Super admins and organization
 * owners count as ADMIN whatever their stored role.
 */
export function effectiveRouteRole(user: unknown): RouteRole {
  const u = (user ?? {}) as Record<string, unknown>;
  const roleRaw = String(u.role || '').toUpperCase();
  if (roleRaw === 'ADMIN' || u.is_super_admin || u.is_organization_owner) return 'ADMIN';
  if (roleRaw === 'AGENT') return 'AGENT';
  if (roleRaw === 'RIDER') return 'RIDER';
  return 'USER';
}

/**
 * Whether `<RoleRoute allowed={allowed}>` renders its page for this user at
 * `pathname`, before its onboarding-automation exception. A user with custom
 * menu permissions passes every gate except the admin-preference pages.
 */
export function roleRouteAllows(user: unknown, allowed: readonly RouteRole[], pathname: string): boolean {
  const hasCustomMenuPermissions = Array.isArray((user as Record<string, unknown> | null)?.menu_permissions);
  if (hasCustomMenuPermissions && !isAdminPreferencePath(pathname)) return true;
  return allowed.includes(effectiveRouteRole(user));
}
